export default __webpack_public_path__ + "static/media/1112.4025000c.png";